export default __webpack_public_path__ + "static/media/Q1.828f9304.jpg";